interface NameParts {
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  suffix?: string | null;
}

const buildFullName = ({ firstName, middleName, lastName, suffix }: NameParts): string =>
  [firstName, middleName, lastName, suffix].filter((part): part is string => Boolean(part?.trim())).join(' ');

export default buildFullName;
